import {Component, OnInit, HostListener} from '@angular/core';
import { NbThemeService, NbToastrService } from '@nebular/theme';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import {MatDialog} from '@angular/material';
import {CustomDialogComponent} from '../../custom_components/custom-dialog/custom-dialog.component';
import { Subscription } from "rxjs/Subscription";
import {NgbDateStruct, NgbCalendar, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import { UtilidadesService } from '../../@core/utils/utilidades.service'
import { NgbDateCustomParserFormatter} from '../../@theme/pipes/dateFormatPicker';
import { LocalDataSource } from 'ng2-smart-table';
import { ModalAddEntidadActividadesComponent } from '../../custom_components/modal-add-entidad-actividades/modal-add-entidad-actividades.component';
import { ModalAddIngresosGastosActividadesComponent } from '../../custom_components/modal-add-ingresos-gastos-actividades/modal-add-ingresos-gastos-actividades.component';
import {AccionesAddEntidadesComponent} from '../../custom_components/AccionesAddEntidades/AccionesAddEntidades.component'
import { DatePipe } from '@angular/common';
import { ModalCheckBoxEntidadActComponent } from '../../custom_components/modal-check-box-entidad-act/modal-check-box-entidad-act.component';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'ngx-actividad-detalle',
  styleUrls: ['./actividad-detalle.component.scss'],
  templateUrl: './actividad-detalle.component.html',
  providers: [PeticionesHttpBackEndService,UtilidadesService,{provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}]
})

export class ActividadDetalleComponent implements OnInit{

  
  /* Variables */
  fecha = new Date();
  tokenRequest:any;
  parametrosUrl: any;
  actividadData:any;
  TipologiasSelect:any[] = [];
  dataTableSedes: any;
  dataTableParticipantes: any;
  dataTableAsistentes: any;
  resultSource:any;
  seleccionado:any;
  calculo:any;
  inscritos:any ="-";
  confirmados:any ="-";
  rechazados:any ="-";
  plazasLibres:any ="-";
  aceptados:any = "-";
  noAceptados:any = "-";
  espera:any ="-";
  bajas:any = "-";
  datepip:any;
  imagenRuta:any ="";
  fileData: File = null;
  JsonSedes: any;
  JsonBusquedaDataEntidad:any;
  resultSedes:any;
  entidadNombre:any = "";
  entidadApellidos:any = "";
  entidadTelefono:any = "";
  entidadDni:any = "";
  entidadEmail:any = "";
  resultInfEconomica:any = "";
  ingresos:any = 0;
  gastos:any = 0;
  ingresosAsistentes:any = 0;
  gastosAsistentes:any = 0;
  resultEntidades:any;
  addMostrar:any = true;
  btnAnadirEntidades:any = "Añadir entidades";
  imagen:any;
  modelSocios:boolean = false;
  modelDesactivar:boolean = false;
  checkSoloSocios:boolean=false;
  checkDesactivar:boolean=false;
  modelCrearMuro:boolean;
  
  resultActividades = {
    "_actividad_id":0,
    "_nombre":"",
    "_edicion":"",
    "_precio_socios":0,
    "_precio":0,
    "_aforo":0,
    "_fecha_inicio":new Date(),
    "_fecha_fin":new Date(),
    "_fecha_inicio_inscripcion":new Date(),
    "_descripcion":"",
    "_duracion":""
  };
  tipologiaId:any;
  ActividadesData:any;
  tipo:any;
  Tipologia = {
    "_tipologia_id":0
  }
  public options: Object = {
    placeholderText: 'Descripción de la actividad...',
    charCounterCount: true
  }

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    placeholder: 'Descripción de la actividad...',
    translate: 'no',
    sanitize: false,
    toolbarPosition: 'top',
    defaultFontName: 'Arial',
    height: '15rem',
    minHeight: '5rem',
  };
  descripcion:any = "";
  /* ---------- */

  /* Datos tablas */
  settingsTableSedes = {
    mode: 'inline',
    sort: true,
    noDataMessage: "No se han encontrado resultados.",
    actions: {
      columnTitle: "Acciones",
      add: false,
      edit: false,
      custom: [
        { name: 'gastoAsistencia', title: '<i class="nb-plus"></i>' },
      ],
    },
    pager: {
			display: true,
			perPage: 3//2
		},
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      Nombre: {
        title: 'Nombre',
        type: 'string',
        filter: true
      },
      Apellidos: {
        title: 'Apellidos',
        type: 'string',
        filter: true
      },
      EmpresaInstitucion: {
        title: 'Nombre de empresa o institución',
        type: 'string',
        filter: true
      }/*,OtrasAcciones: {
        title: 'Otros',
				type: 'custom',
				renderComponent: AccionesAddEntidadesComponent,
				filter: false,
				sort: false
      }*/
    },
  };

  sourceTableSedes: LocalDataSource = new LocalDataSource();

  settingsTableParticipantes = {
    mode: 'inline',
    sort: true,
    noDataMessage: "No se han encontrado resultados.",
    actions: {
      columnTitle: "Acciones",
      add: false,
      edit: false,
      custom: [
        { name: 'gastoAsistencia', title: '<i class="nb-plus"></i>' },
      ],
    },
    pager: {
			display: true,
			perPage: 3//2
		},
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      Nombre: {
        title: 'Nombre',
        type: 'string',
        filter: true
      },
      Apellidos: {
        title: 'Apellidos',
        type: 'string',
        filter: true
      },
      Cargo: {
        title: 'Cargo',
        type: 'string',
        filter: true
      }/*,
      OtrasAcciones: {
        title: 'Otros',
				type: 'custom',
				renderComponent: AccionesAddEntidadesComponent,
				filter: false,
				sort: false,
				class: 'text-center'
      }*/
    },
  };

  sourceTableParticipantes: LocalDataSource = new LocalDataSource();

  settingsTableAsistentes = {
    mode: 'inline',
    sort: true,
    noDataMessage: "No se han encontrado resultados.",
    actions: {
      columnTitle: "Acciones",
      add: false,
      edit: false,
      custom: [
        { name: 'gastoAsistencia', title: '<i class="nb-plus"></i>' },
      ],
    },
    pager: {
			display: true,
			perPage: 3//2
		},
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      Nombre: {
        title: 'Nombre',
        type: 'string',
        filter: true
      },
      Apellidos: {
        title: 'Apellidos',
        type: 'string',
        filter: true
      },
      ConfirmacionPago: {
        title: 'Estado de pago',
        type: 'string',
        filter: true,
        valuePrepareFunction: (estado) => {
					if (estado) {
						return "Pagado";
					}else{
            return "No pagado";
          }
				}
      },
      FechaPago: {
        title: 'Fecha de pago',
        type: 'string',
        filter: true,
        valuePrepareFunction:(date) => {
					if (date) {
						return this.datepip.transform(date, "dd-MM-yyyy");
					}else{
            return "-";
          }
				}
      },
      EnEspera: {
        title: 'Lista de espera',
        type: 'string',
        filter: false,
        valuePrepareFunction:(enEspera) => {
					if (enEspera) {
						return "Si";
					}else{
            return "No";
          }
				}
      },
      OrdenListaEspera: {
        title: 'Orden lista de espera',
        type: 'string',
        filter: false
      },
      Empresa:{
        title: 'Relacionado con empresa',
        type: 'string',
        filter: false,
        valuePrepareFunction:(empresa) => {
					if (empresa) {
						return 'Si';
					}else{
            return "No";
          }
				}
      }/*,
      OtrasAcciones: {
        title: 'Otros',
				type: 'custom',
				renderComponent: AccionesAddEntidadesComponent,
				filter: false,
				sort: false
      }*/
    },
  };

  sourceTableAsistentes: LocalDataSource = new LocalDataSource();

  settingsTableFactura = {
    mode: 'inline',
    sort: true,
    noDataMessage: "No se han encontrado resultados.",
    actions: {
      columnTitle: "Acciones",
      add: false,
      edit: false,
    
    },
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      Nombre: {
        title: 'Entidad',
        type: 'string',
        filter: false
      },
      Concepto: {
        title: 'Concpeto',
        type: 'string',
        filter: false
      },
      EsIngreso: {
        title: 'Tipo de Ingreso',
        type: 'string',
        filter: false,
        valuePrepareFunction:(ingreso) => {
					if (ingreso) {
						return "Ingresos";
					}else{
            return "Gastos";
          }
				}
      },
      Cantidad: {
        title: 'Importe',
        type: 'string',
        filter: false,
        valuePrepareFunction:(cantidad) => {
					return +cantidad;
				}
      },
      FechaMovimiento: {
        title: 'Fecha movimiento',
        type: 'string',
        filter: false,
        valuePrepareFunction:(date) => {
					return this.datepip.transform(date, "dd-MM-yyyy");
				}
      }
    },
  };

  sourceTableFactura: LocalDataSource = new LocalDataSource();
  dataa = [
    {
      Nombre: "PEPE",
      Apellidos: "Leanne Graham",
      EmpresaInstitucion: "Bret",
    }
  ];
  //Configuracion para la tabla de entidades para poder añadir actividades a estas
  /*settings = {
    mode: 'inline',
    sort: true,
    noDataMessage: "No se han encontrado resultados.",
    actions: {
      columnTitle: "Acciones",
      add: false,
      edit: false,
      delete:false
    },
    pager: {
			display: true,
			perPage: 3//2
		},
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      _nombre: {
        title: 'Nombre',
        type: 'string',
        filter: true
      },
      _apellidos: {
        title: 'Apellidos',
        type: 'string',
        filter: true
      },
      _nombre_empresa_institucion: {
        title: 'Nombre de empresa o institución',
        type: 'string',
        filter: true
      },
      _email: {
        title: 'Email',
        type: 'string',
        filter: true
      }
    },
  };
  source: LocalDataSource = new LocalDataSource();*/
  constructor(private utilidades: UtilidadesService, private calendar: NgbCalendar,private _route: ActivatedRoute, public dialog: MatDialog,private themeService: NbThemeService,private toastrService: NbToastrService,private router:Router,private authService: NbAuthService,public _PeticionesHttpBackEndService: PeticionesHttpBackEndService,datepipe: DatePipe) {
  this._route.queryParams.subscribe(params => {
    this.parametrosUrl = params || null;
  });
  this.actividadData = {Actividad:{}};
  this.TipologiasSelect = [];
  this.datepip = datepipe;
  this.modelCrearMuro = false;

  }

  handleFileInput(event){
    this.fileData = event.target.files[0];
    }
    onSubmit() {
      let resultado;
      const formData = new FormData();
      formData.append('file', this.fileData);

      this._PeticionesHttpBackEndService.uploadFileActividades(formData,this.resultActividades._actividad_id, true)

        .subscribe(res => {
          resultado = res;
          if (resultado.Code == 200){
            this.imagenRuta = resultado.Archivo.original_name;
            this.cargarDatosBasicos();
            this.utilidades.notificationSuccess("Correcto","El archivo ha sido subido correctamente","top-left");
          }else{
            this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
          }
          
        })
    }
  editarActividad(): void {
    if(this.resultActividades._nombre == '' || this.resultActividades._nombre == undefined 
    || this.resultActividades._edicion == '' || this.resultActividades._edicion == undefined 
    || (this.tipo == '' || this.tipo == undefined) && (this.tipologiaId =='' || this.tipologiaId == undefined) 
    || this.resultActividades._precio_socios == undefined 
    || this.resultActividades._precio == undefined 
    || this.resultActividades._duracion == '' || this.resultActividades._duracion == undefined 
    || this.resultActividades._aforo == 0 || this.resultActividades._aforo == undefined
    ||  this.resultActividades._fecha_inicio == undefined
    ||  this.resultActividades._fecha_fin == undefined
    ||  this.resultActividades._fecha_inicio_inscripcion == undefined
    || this.resultActividades._descripcion == '' || this.resultActividades._descripcion == undefined){
      this.utilidades.notificationWarning("Aviso","Debe rellenar todos los campos","top-left");
         
    }else{
      if(this.tipo == undefined){
        this.tipo = this.tipologiaId;
      }
      //"Imagen":this.imagenRuta,
        this._PeticionesHttpBackEndService.insertaObjecto("v1/editActividad",{Data: {"Titulo":this.resultActividades._nombre,"TipologiaId":this.tipo,"FechaInicio":this.datepip.transform(this.resultActividades._fecha_inicio, "yyyy-MM-dd"),
          "FechaFin":this.datepip.transform(this.resultActividades._fecha_fin, "yyyy-MM-dd"),"PrecioSocios":this.resultActividades._precio_socios,"PrecioNoSocios":this.resultActividades._precio,"Aforo":this.resultActividades._aforo,
          "Duracion":this.resultActividades._duracion,"Edicion":this.resultActividades._edicion,"FechaInscripcion":this.datepip.transform(this.resultActividades._fecha_inicio_inscripcion, "yyyy-MM-dd"),"Descripcion":this.resultActividades._descripcion,"ActividadId":this.parametrosUrl.ActividadId,"SoloSocios":this.checkSoloSocios,"Desactivar":this.checkDesactivar,'CrearMuro':this.modelCrearMuro}}).subscribe(
            result => {
              let resultado;
              resultado = result;
              if (resultado.Code == 500){
                this.utilidades.notificationWarning("Error",""+resultado.message+"","top-left");
              }else{
                this.utilidades.notificationSuccess("Éxito","Actividad modificada con éxito","top-left");
              }
            },
            error => {
            }
          );
    }
  }

  AddIngresoGasto(): void {
    let dialogRef = this.dialog.open(ModalAddIngresosGastosActividadesComponent, {
      panelClass: 'custom-dialog',
      minWidth: 1000,
      data: {
        titulo: "Esto es el titulo",
        contenido: "<p>Este es el contenido</p>"
      }
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result == 0 || result == undefined){
          //this.notificationWarning("Error","Debe seleccionar una opcion","top-left")
      }else{
        //this.submitAddRedSocial(result);
      }
    });
  }

  setActividadFechaInicio(event){
    let dia = event.day;
    let mes = event.month;
    
    if (dia < 10){ dia = "0"+event.day;} 
    if (mes < 10){ mes = "0"+event.month;} 

    let fecha = event.year+"-"+mes+"-"+dia+"";
    this.actividadData.Actividad._fecha_inicio = fecha;
  }


  setActividadFechaFin(event){
    let dia = event.day;
    let mes = event.month;
    
    if (dia < 10){ dia = "0"+event.day;} 
    if (mes < 10){ mes = "0"+event.month;} 

    let fecha = event.year+"-"+mes+"-"+dia+"";
    this.actividadData.Actividad._fecha_fin = fecha;
  }

  setDatosBasicos(event){
    let elemento = event.target.tagName;
    let tipo = event.target.type;
    if ((elemento == "INPUT" && tipo == "text") || (elemento == "INPUT" && tipo == "number")){
      switch(event.target.name){
        case "_titulo": this.actividadData.Actividad._titulo = event.target.value; break;
        case "_edicion": this.actividadData.Actividad._edicion = event.target.value; break;
        case "_precio": this.actividadData.Actividad._precio = event.target.value; break;
        case "_aforo": this.actividadData.Actividad._aforo = event.target.value; break;
      }
    }

    if (elemento == "SELECT" && tipo == "select-one"){
      switch(event.target.name){
        case "_tipologia_actividad_id": this.actividadData.Actividad._tipologia_actividad_id = event.target.value; break;
      }
    }
  }

  guardaDatosBasicos(){
    let resultado;
    this._PeticionesHttpBackEndService.updateOneReg("v1/updateActividadCurso/datosBasicos",this.parametrosUrl["ActividadId"],{data:this.actividadData.Actividad}).subscribe(
      result => {
        resultado = result;
        if (resultado.Code == 200){
          this.utilidades.notificationSuccess("Éxito","Los datos han sido actualizados","top-left");
        }else{
          this.utilidades.notificationWarning("Error: "+resultado.Code+"",resultado.Mensaje,"top-left");
        }
      },
      error => {
        if (error.error.code == 401){
          /* Si hay un error 401 es que el token no es válido, por lo tanto, redirecciono a login */
          //this.router.navigate(['/auth/login']);
       }
      }
    );
  }
  


 ngOnInit(){
  
 }


 onSearchEntidades(query: string = '') {
  /*
  this._PeticionesHttpBackEndService.postRequest(this.tokenRequest,"v1/BusquedaActividades",{Data:this.JsonBusquedaData}).subscribe(
    result => {
      this.ActividadesData = [];
      this.resultadoRequest = result;
        for (let Actividad of this.resultadoRequest.Actividades) {
              this.ActividadesData.push({ActividadId:Actividad.ActividadId,Titulo:Actividad.Titulo,Tipo:Actividad.TipoActividad,Inicio:Actividad.FechaInicio,Fin:Actividad.FechaFin});
        }

      this.source.load(this.ActividadesData);
    },
    error => {

    }
  );
  */
}

onChangeTab(event){
    /*if(event.tabTitle == "Entidades"){ // Carga las entidades para poder añadirlas a las actividades
      this.cargarEntidades();
    }else */if(event.tabTitle == "Información económica"){
      this.cargarInformacionEconomica();
    }else if(event.tabTitle == "Datos básicos"){
      this.cargarDatosBasicos();
    }
}

onChangeEntidades(event){
    if(event.tabTitle == "Sede"){
      this.cargarSede();
    }else if(event.tabTitle == "Participantes"){
      this.cargarParticipante();
    }else if(event.tabTitle == "Asistentes"){
      this.cargarAsistentes();
    }
}

/*cargarEntidades(){ //Carga las entidades para poder añadirlas a las actividades
  this._PeticionesHttpBackEndService.getAllReg("v1/entidades").subscribe(
    result => {
      this.resultEntidades = result;
      this.source.load(this.resultEntidades.Entidades);
    },
    error => {
      this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al cargar la tabla de entidades"+"","top-left");
    });
}*/

/*mostrarEntidades(){ servia para mostrar y ocultar la tabla de entidades para añadirlas a las actividades
  if(this.addMostrar){
    this.btnAnadirEntidades = " Ocultar entidades";
    this.addMostrar = false;
  }else {
    this.btnAnadirEntidades = " Añadir entidades";
    this.addMostrar = true;
  }
}*/

cargarInformacionEconomica(){
  this._PeticionesHttpBackEndService.getActividadesById("v1/getFacturas",this.parametrosUrl.ActividadId).subscribe(
    result => {
      this.resultInfEconomica = result;
      
      let ingresos = 0;
      let gastos = 0;
      let ingresosAsistentes = 0;
      let gastosAsistentes = 0;
      this.resultInfEconomica.Ingresos.forEach(function(element) {
        if(element.EsIngreso){
          ingresos = ingresos+ (+element.Cantidad);
          if(element.ActividadEntidadTipoId == 3){
            ingresosAsistentes = ingresosAsistentes+ (+element.Cantidad);
          }
        }else{
          gastos = gastos+(+element.Cantidad);
          if(element.ActividadEntidadTipoId == 3){
            gastosAsistentes = gastosAsistentes+(+element.Cantidad);
          }
        }
      });
    
      this.ingresos  = +ingresos;
      this.gastos = +gastos;
      this.ingresosAsistentes = +ingresosAsistentes;
      this.gastosAsistentes = +gastosAsistentes;
      this.sourceTableFactura.load(this.resultInfEconomica.Ingresos);
    },
    error => {
      this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al cargar la información económica"+"","top-left");
    });
}

setStylesIngresosGastos() {
  let styles = {
    'background-color': (this.ingresos - this.gastos)<0 ? 'red' : 'green',
    'border-radius': '5px',
    'color': 'white',
    'padding': '0.8em'
  };
  return styles;
}

setStylesIngresosGastosAsistentes() {
  let styles = {
    'background-color': (this.ingresosAsistentes - this.gastosAsistentes)<0 ? 'red' : 'green',
    'border-radius': '5px',
    'color': 'white',
    'padding': '0.8em'
  };
  return styles;
}

cargarDatosBasicos(){
  this.authService.getToken()
  .subscribe((token: NbAuthJWTToken) => {
    if (token.isValid()) {
      this.tokenRequest = token;
       /* Peticiones API */
       this._PeticionesHttpBackEndService.getActividadesById("v1/actividadesById",this.parametrosUrl.ActividadId).subscribe(
         result => {
           this.resultSource = result;
           this.resultActividades._actividad_id = this.resultSource.Actividades._actividad_id;
           this.resultActividades._aforo = this.resultSource.Actividades._aforo;
           this.resultActividades._edicion = this.resultSource.Actividades._edicion;
           this.resultActividades._fecha_fin = new Date(this.resultSource.Actividades._fecha_fin);
           this.resultActividades._fecha_inicio = new Date(this.resultSource.Actividades._fecha_inicio);
           this.resultActividades._fecha_inicio_inscripcion= new Date(this.resultSource.Actividades._fecha_inicio_inscripcion);
           this.resultActividades._nombre = this.resultSource.Actividades._nombre;
           this.resultActividades._precio = this.resultSource.Actividades._precio;
           this.resultActividades._precio_socios = this.resultSource.Actividades._precio_socios;
           this.resultActividades._descripcion = this.resultSource.Actividades._descripcion;
           this.tipologiaId = this.resultSource.Actividades._tipologia_id;
           this.seleccionado  = this.tipologiaId._nombre;
           this.resultActividades._duracion = this.resultSource.Actividades._duracion;
           this.modelSocios = this.resultSource.Actividades._solo_socios;
           this.checkSoloSocios = this.resultSource.Actividades._solo_socios;
           this.modelDesactivar = this.resultSource.Actividades._desactivar;
           this.checkDesactivar = this.resultSource.Actividades._desactivar;
           this.modelCrearMuro = this.resultSource.MuroCreado;


           this.imagen = this.resultSource.Imagen;

           this._PeticionesHttpBackEndService.getAllTipologias("v1/tipologias").subscribe( 
             result => {
               this.resultSource = result;
               this.TipologiasSelect = this.resultSource.Tipologia;
               /*for (let Actividad of this.TipologiasSelect) {
                 this.ActividadesData.push({ActividadId:Actividad.ActividadId,Titulo:Actividad.Titulo,Tipo:Actividad.TipoActividad,Inicio:Actividad.FechaInicio,Fin:Actividad.FechaFin});
               }*/
           
             },
             error => {
              this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al cargar las tipologias"+"","top-left");
             }
           );
         },
         error => {
          this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al encontrar la actividad"+"","top-left");
         }
       );

                 
       this._PeticionesHttpBackEndService.getCaculoDatosActividades("v1/calculoDatosActividades",this.parametrosUrl.ActividadId).subscribe( 
         result => {
           this.calculo = result;
           if(this.calculo.Calculo != ""){
           /* this.inscritos = this.calculo.Calculo.inscriptos;
            this.confirmados = this.calculo.Calculo.confirmados;
            this.rechazados = this.calculo.Calculo.rechazados;
            this.plazasLibres = this.calculo.Calculo.plazasLibres;
            this.espera = this.calculo.Calculo.espera;
            this.bajas = this.calculo.Calculo.bajas;*/

            this.inscritos = this.calculo.Calculo.inscritos;
            this.aceptados = this.calculo.Calculo.aceptados
            this.confirmados = this.calculo.Calculo.confirmados
            this.noAceptados = this.calculo.Calculo.noAceptados
            this.plazasLibres = this.calculo.Calculo.plazasLibres
            this.espera = this.calculo.Calculo.espera
            this.bajas = this.calculo.Calculo.bajas



           }
          
         },
         error => {
          this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al calcular los datos de las actividades"+"","top-left");
         }
       );
      
       /* ./Peticiones API */
    }
  });
}

cargarSede(){
 
  this.JsonSedes = {ActividadId:this.parametrosUrl.ActividadId,TipoActividadEntidad:1};
  this._PeticionesHttpBackEndService.postGeneralConParametro("entidadesByEntAndAct",{Data:this.JsonSedes}).subscribe( 
    result => {
      this.resultSedes = result;
     this.sourceTableSedes.load(this.resultSedes.Entidades);
    },
    error => {
      this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al cargar las sedes"+"","top-left");
    }
  );
}
cargarParticipante(){
  this.JsonSedes = {ActividadId:this.parametrosUrl.ActividadId,TipoActividadEntidad:2};
  this._PeticionesHttpBackEndService.postGeneralConParametro("entidadesByEntAndActPart",{Data:this.JsonSedes}).subscribe( 
    result => {
      this.resultSedes = result;
     this.sourceTableParticipantes.load(this.resultSedes.Entidades);
    },
    error => {
      this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al cargar los participantes"+"","top-left");
    }
  );
}
cargarAsistentes(){
  this.JsonSedes = {ActividadId:this.parametrosUrl.ActividadId,TipoActividadEntidad:3};
  this._PeticionesHttpBackEndService.postGeneralConParametro("entidadesByEntAndActAsis",{Data:this.JsonSedes}).subscribe( 
    result => {
      this.resultSedes = result;
     this.sourceTableAsistentes.load(this.resultSedes.Entidades);
    },
    error => {
      this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al cargar los asistentes"+"","top-left");
    }
  );
}

onDeleteConfirmEntidades(event){
  if (window.confirm('¿Seguro que quieres eliminar esta actividad? Con esto borrarás todos sus datos y no tiene vuelta atrás.')) {
    this._PeticionesHttpBackEndService.deleteOneReg("v1/eliminarActEnt",event.data.ActividadEntidadId).subscribe( 
      result => {
        this.resultSource = result;
        this.utilidades.notificationSuccess("Éxito","La actividad ha sido eliminada correctamente","top-left");
        event.confirm.resolve();
      },
      error => {
        this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al eliminar la actividad"+"","top-left");
      }
    );
  } else {
    event.confirm.reject();
  }  
}

onDeleteConfirmAsistentes(event){
  this.JsonSedes = {ActividadId:this.parametrosUrl.ActividadId,EntidadId:event.data.EntidadId,FechaPago:event.data.FechaPago == undefined ? "":event.data.FechaPago,Pagado:event.data.ConfirmacionPago == null ? false : event.data.ConfirmacionPago,ActividadEntidadId:event.data.ActividadEntidadId};
  if (window.confirm('¿Seguro que quieres eliminar esta actividad? Con esto borrarás todos sus datos y no tiene vuelta atrás.')) {
    this._PeticionesHttpBackEndService.deleteOneRegAsistentes("eliminarActEntAsistenes",{Data:this.JsonSedes}).subscribe( 
      result => {
        
        this.resultSource = result;
        this.cargarAsistentes()
        this.utilidades.notificationSuccess("Éxito","La actividad ha sido eliminada correctamente","top-left");
        event.confirm.resolve();
      },
      error => {
        this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al eliminar la actividad"+"","top-left");
      }
    );
  } else {
    event.confirm.reject();
  }
  
}
onDeleteConfirmFactura(event){
  if (window.confirm('¿Seguro que quieres eliminar este importe? Con esto borrarás todos sus datos y no tiene vuelta atrás.')) {
    this._PeticionesHttpBackEndService.deleteOneReg("v1/eliminarIngresos",event.data.IngresoGastoId).subscribe( 
      result => {
        this.resultSource = result;
        this.utilidades.notificationSuccess("Éxito","El ingreso ha sido eliminada correctamente","top-left");
        this.cargarInformacionEconomica();
        event.confirm.resolve();
        
      },
      error => {
        this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al eliminar el ingreso"+"","top-left");
      }
    );
  } else {
    event.confirm.reject();
  }
}
buscarEntidad(){
  let dialogRef = this.dialog.open(ModalAddEntidadActividadesComponent, {
    panelClass: 'custom-dialog',
    data: {
      ActividadId: this.parametrosUrl.ActividadId,
     
    }
  });
  dialogRef.afterClosed().subscribe(result => {
    this.cargarParticipante();
    this.cargarSede();
    this.cargarAsistentes();
  });
}
onCustomAction(event){
  let dialogRef = this.dialog.open(ModalAddIngresosGastosActividadesComponent, {
    panelClass: 'custom-dialog',
    data: {
      contenido: event.data
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    this.ngOnInit();
  });
}
auxPrecioNoSocio:number = 0;
soloSocios(checked: any) {
  this.checkSoloSocios = this.modelSocios;
  if(this.checkSoloSocios){
    this.auxPrecioNoSocio = this.resultActividades._precio;
    this.resultActividades._precio = 0;
  }else{
    this.resultActividades._precio = this.auxPrecioNoSocio;
  }
}
changeDesactivar(checked: any) {
  this.checkDesactivar = this.modelDesactivar;
}
/*onRowAddEntSelect(event) Funcion para seleccionar una entidad y añadirla a la actividad
  {
    let dialogRef = this.dialog.open(ModalCheckBoxEntidadActComponent, {
      panelClass: 'custom-dialog',
      data: {
        entidad: event.data,
        actividadId: this.parametrosUrl.ActividadId
      }
    });
  
    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }*/
  
} /* Termina la clase */


